import React from 'react'
import ReactApexChart from 'react-apexcharts';
import pl from "apexcharts/dist/locales/pl.json";

const HorizontalBarChartManagement = (props) => {
  const valueConvert = (val, prec = 2) => {
    if (typeof val === typeof 1) return (Number(val).toFixed(prec)).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".", ",")
    return val
  }
  const { dataChart, opkSelect, dataNames } = props
  const colorPalette = ['#6a76bc', '#c9c9dd']//["#ee8181", '#2681b4'] 
  // const dataNames = ["Koszty stałe OPK", "Koszty zmienne OPK"]

  const retData = () => {
    if (dataChart != null) {
      let data = {
        series: dataNames.map(item => {
          return {
            name: item,
            data: Object.entries(dataChart).map(([opk, values], i) => {
              return values[item]
            }).slice(0, -1)
          }
        })
      }
      data.options = {
        chart: {
          type: 'bar',  
          
          locales: [pl],
        defaultLocale: 'pl',
        
          
          height: 400,
          barHeight: dataNames.length == 1 ? '35%' : '70%'
         
        },
        colors: colorPalette,
        fill: {
          colors: [function ({ value, seriesIndex, w }) {
            if (dataNames.length == 1) {
              return value < 0 ? '#ee8181' : '#6bd098'
            } else {
              return colorPalette[seriesIndex]
            }
          }]
        },
        grid: { show: false },
        plotOptions: {
          bar: {
            locales: [pl],
            defaultLocale: 'pl',
            horizontal: true,
            endingShape: 'rounded',
            borderRadius: 5,
            dataLabels: {
              position: 'top', // top, center, bottom
              hideOverflowingLabels: false
            },
          }
        },
        dataLabels: {
          enabled: false,
          textAnchor: 'middle',
          formatter: function (val, opt) {
            return val ? valueConvert(val) : ''
          },
          style: {
            fontSize: '12px',
            colors: ["#304758"],
            fontFamily: "Montserrat, Helvetica Neue",
            fontWeight: 400
          }
        },
        xaxis: {
          categories: Object.keys(dataChart).slice(0, -1),
          showAlways: true,
          labels: { maxHeight: 500 },
          opposite: false,
          labels: {
            formatter: (val) => {
              return valueConvert(val, 0)
            },
          }
        },
        yaxis: {
          show: true,
          opposite: false,
          labels: {
            formatter: (val) => {
              return val
            },
          },
          title: {
            text: 'Kod funkcji',
            offsetX: 10,
            style: {
              fontSize: '14px',
              fontWeight: 400,
              fontFamily: "Montserrat, Helvetica Neue",
              color: '#263238'
            },
          }
        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'center',
          fontSize: '14px',
          fontFamily: "Montserrat, Helvetica Neue",
          color: '#263238',
          showForSingleSeries: true,
          showForNullSeries: true,
          showForZeroSeries: true,
          markers: {
            fillColors: dataNames.length == 1 ? ['#6bd098', '#ee8181'] : colorPalette,
          },
          customLegendItems: dataNames.length == 1 ? [dataNames[0] + ' w zł (dodatni)', dataNames[0] + ' w zł (ujemny)'] : dataNames.map(item => { return item + ' w zł' }),
        },
        tooltip: {
          followCursor: true,
          shared: false,
          custom: function ({ series, seriesIndex, dataPointIndex }) {
            let tooltip = '<div class="arrow-box chart-tooltip" >'
            tooltip += '<div style="padding: 3px; font-weight: bold ">' + dataNames[seriesIndex] + '</div>'
            tooltip += '<div>'
            tooltip += valueConvert(series[seriesIndex][dataPointIndex]) + ' zł<br>'
            tooltip += '</div></div>'
            return tooltip
          }
        },
      }
      if (Object.keys(dataChart).length > 6) data.options.chart.height = 400 + (Object.keys(dataChart).length - 6) * 30

      return data
    } else return null
  }
  const [chartData, setChartData] = React.useState({ series: [], options: { chart: { height: 500, type: 'bar' } } })
  React.useEffect(() => {
    setChartData(retData())
  }, [dataChart])



  if (chartData) {
    return (<>
      <div>
        <ReactApexChart
          type={chartData.options.chart.type}
          series={chartData.series}
          options={chartData.options}
          height={chartData.options.chart.height}
        /> </div>
    </>
    )
  } else return <></>
}
export default HorizontalBarChartManagement
